// @ts-nocheck
import { SplitOrderCartNotesModel } from "@insite/client-framework/Types/ApiModels";
import {
    UpdateSplitOrderCartNotesAPIParameters,
    updateSplitOrderCartNotesWithResult as updateSplitOrderCartNotesLineApi,
} from "@store/Framework/Services/SplitOrderCartLineService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

interface UpdateSplitOrderCartNotesParameter {
    onSuccess?: () => void;
    splitOrderCartNotes: SplitOrderCartNotesModel;
}

type HandlerType = ApiHandlerDiscreteParameter<
    UpdateSplitOrderCartNotesParameter,
    UpdateSplitOrderCartNotesAPIParameters
>;

export const DispatchBeginUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/SubmitAndReview/BeginUpdateSplitOrderCartLine",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { splitOrderCartNotes, ...newParameter } = props.parameter;
    props.apiParameter = {
        splitOrderCartNotes,
        ...newParameter,
    };
};

export const UpdateCartNotes: HandlerType = async props => {
    try {
        await updateSplitOrderCartNotesLineApi(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Greif/Pages/SubmitAndReview/FailedToUpdateSplitOrderCartLine",
            });
            return false;
        }

        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const DispatchCompleteUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Greif/Pages/SubmitAndReview/CompleteUpdateSplitOrderCartLine",
    });
};

export const chain = [
    DispatchBeginUpdateCartLine,
    PopulateApiParameter,
    UpdateCartNotes,
    DispatchCompleteUpdateCartLine,
    ExecuteOnSuccessCallback,
];

const updateSplitOrderCartNotes = createHandlerChainRunner(chain, "UpdateSplitOrderCartLine");
export default updateSplitOrderCartNotes;
